export default __webpack_public_path__ + "assets/models/5095a36f061fe71fc338287ac87549ea.gltf";